// @flow
import type {
  BillingInfoOperation,
} from '../types'

export default ({
  billingInfoOperation: {},
}: {
  billingInfoOperation: BillingInfoOperation,
})
